<template>
	<section class="col-xs-12 block versiculo__des">
		<div class="container min">
			<div class="row">
				<h3>VERSICULO DEL DIA</h3>
				<img v-if="versiculo.better_featured_image!=null" v-bind:src="versiculo.better_featured_image.source_url">
				<p>{{versiculo.soloexcerpt}}</p>
				<p class="cita">{{versiculo.title.rendered}}</p>
				<div class="compartir">
					<span>Compartir en</span>
					<ul>
						<li><a v-bind:href="'https://www.facebook.com/sharer/sharer.php?u='+versiculo.link" target="_blank"><i class="fa fa-facebook"></i></a></li>
						<li><a v-bind:href="'https://twitter.com/share?text='+versiculo.title.rendered" target="_blank"><i class="fa fa-twitter"></i></a></li>
						<li class="itemwa"><a v-bind:href="'whatsapp://send?text='+versiculo.soloexcerpt+' '+versiculo.title.rendered+' '+versiculo.link"><i class="fa fa-whatsapp"></i></a></li>
					</ul>
					<a v-bind:href="versiculo.better_featured_image.source_url" class="versiculo__descargar">DESCARGAR</a>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	mounted: function() {
		const vm = this;
		if ( vm.$route.params.elversiculo ) {
			vm.getVersiculo( vm.$route.params.elversiculo );
		}
	},
	data() {
		return {
			theme_url:rtwp.theme_url,
			_locutor: {},
			_programas: {},
			_postslocutor: {},
			audiosprograma: {},
			loaded: 'false',
			loaded_programas: 'false',
			loaded_author: 'false',
			loaded_audiosprograma:'false',
			pageTitle: '',
			catName: '',
			versiculo: {},
		};
	},
	methods: {
		getPostsAuthor: function( locutorId ) {
			const vm = this;
			vm.loaded_author = 'false';
			vm.$http.get( 'wp/v2/posts', {
				params: { ellocutor: locutorId, per_page:4,orderby:'rand' }
			} )
			.then( ( res ) => {
				vm._postslocutor = res.data;
				console.log(vm._postslocutor);
				if(res.data.length>0){
					vm.loaded_author = 'true';
				}
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		},
		getProgramas: function( progsID ) {
			const vm = this;
			vm.loaded_programas = 'false';
			vm.$http.get( 'wp/v2/programas', {
				params: { include: progsID }
			} )
			.then( ( res ) => {
				vm._programas = res.data;
				vm.loaded_programas = 'true';
				vm.getAudiosPrograma(progsID);
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		},
		getAudiosPrograma:function(idPrograma){
			const vm = this;
			vm.loaded_audiosprograma = 'false';
			// console.log(idPrograma);
			vm.$http.get( 'wp/v2/posts', {
				params: { categories: '7', elprograma: idPrograma}
			} )
			.then( ( res ) => {
				// console.log(res.data);
				vm.audiosprograma = res.data;
				if(res.data.length>0){
					vm.loaded_audiosprograma = 'true';
				}

				vm.$nextTick(function(){
					jQuery(".player__playlist").musicPlayer();
					init_attach();
				});

			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		},
		getVersiculo: function( locutor ) {
			const vm = this;
			vm.loaded = 'false';
			vm.$http.get( 'wp/v2/versiculo?slug=' + locutor )
			.then( ( res ) => {
				res = res.data[ 0 ];
				vm.loaded = 'true';
				vm.versiculo=res;
				console.log(vm.versiculo);
				vm.pageTitle = res.title.rendered;
				vm.$store.commit( 'rtChangeTitle', vm.pageTitle );
				/*var _tmpprogs='';
				res.acf.programas.forEach(function(item){
					_tmpprogs=_tmpprogs+','+item.ID;
				});
				_tmpprogs=_tmpprogs.substring(1)
				// console.log(_tmpprogs);
				vm.getProgramas(_tmpprogs);
				vm.getPostsAuthor( res.id );
				vm.LaCat=res;*/
				vm.$nextTick(function(){
					init_attach();
				});
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		}
	}

};
</script>






// WEBPACK FOOTER //
// interna_versiculo.vue?e5884380